$(function () {
    /**
     * Boostrap fix to support opening modals from stretched links inside a card component.
     */
     $('.card').click(function (e) {
        if ($(this).find('.stretched-link[data-toggle=modal]').length > 0) {
            // Get target from data-attribute
            let target = $(this).find('.stretched-link').first().data('target')

            // Fallback to href
            if (typeof target === 'undefined') {
                target = $(this).find('.stretched-link').first().attr('href')
            }

            // Open modal
            $(target).modal('show')

            // Prevent further events
            e.preventDefault()
            e.stopPropagation()
        }
    })
 });
